import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Footer = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/api/get_product"
      )
      .then((res) => {
        const allProducts = res.data;

        // Extract product names
        const productNames = allProducts.map((p) => p.name).filter(Boolean);

        setProducts(productNames);
      })
      .catch((err) => {
        console.error("Footer Product API Error:", err);
      });
  }, []);

  return (
    <footer
      className="footer"
      style={{
        backgroundImage: "url(/assets/images/foot_bg.jpg)",
        backgroundPosition: "0 -15%",
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
      }}
    >
      {/* Footer Top */}
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-xl-3 col-lg-3 col-md-6">
              <div className="widget widget_info">
                <div className="footer-logo">
                  <a href="#">
                    <img src="/assets/images/bioversal-white1.png" alt="" />
                  </a>
                </div>
                <div className="ft-contact">
                  <p>
                    Bioversal Remedies (leading division of Medical Services) is effectively associated with assembling and trading best quality approved Range of Drug Tablets, Syrups, Capsules, Injectables.
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-xl-3 col-lg-3 col-6">
              <div className="widget footer_widget ml-50">
                <h3 className="footer-title">Quick Links</h3>
                <ul className="footer__links_7">
                  <li>
                    <Link to={"/company-overview"}>
                      <span>Company Overview</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/pharma-franchise">
                      <span>Pharma Franchise</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/PharmaFranchiseCompany">
                      <span>Pharma Franchise Companies</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/pcd-pharma-franchise"} href="#">
                      <span>PCD Pharma Franchise</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/indian-pcd-pharma-companies">
                      <span>Indian PCD Pharma Companies</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/pcd-pharma-companies">
                      <span>PCD Pharma Companies</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/pcd-pharma-franchise-company">
                      <span>PCD Pharma Franchise Company</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/third-party-pharma-manufacturing"}>
                      <span>Third Party Pharma Manufacturing</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

          {/* Our Products – Dynamic */}
<div className="col-xl-3 col-lg-3 col-6">
  <div className="widget footer_widget ml-50">
    <h3 className="footer-title">Our Products</h3>

    <ul className="footer__links_7">
      {products.length > 0 ? (
        <>
          {products.slice(0, 5).map((name, index) => (
            <li key={index}>
              <Link to={`/product-list?name=${encodeURIComponent(name)}`}>
                <span>{name}</span>
              </Link>
            </li>
          ))}

          <li>
            <Link to="/product-list">
              <span>View All Products</span>
            </Link>
          </li>
        </>
      ) : (
        <li>Loading...</li>
      )}
    </ul>
  </div>
</div>
            {/* Contact Info */}
            <div className="col-xl-3 col-lg-3 col-6">
              <div className="widget footer_widget">
                <h3 className="footer-title">Contact Information</h3>
                <ul className="footer__links_7">
                  <li>
                    <span className="foot_add_1" style={{ color: "#fff" }}>
                      <img src="/assets/images/address.png" alt="address icon" style={{ marginRight: 10 }} />
                      2A, Partap Spintex Street, Dukheri Road, Mohra - 133004
                    </span>
                  </li>
                  <li>
                    <a href="tel:+919053777905">
                      <span className="foot_cont_1">
                        <img src="/assets/images/mobile.png" alt="" /> +91 90537-77905 <br /> +91 90538-88905
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:bioversalremedies@gmail.com">
                      <span className="foot_mail_1">
                        <img src="/assets/images/mail.png" alt="" /> bioversalremedies@gmail.com
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="container">
        <div className="footer-bottom">
          <div className="row">
            <div className="col-12 text-center">
              <p className="copyright-text">
                Bioversal Remedies Copyright © 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
